import { useInitialization } from 'components/InitializationProvider';
import { useMenuSelection } from 'global/MenuSelectionContext';

const RequireMenuInitialized = ({ children }: { children: React.ReactNode }) => {
  const { isInitialized } = useMenuSelection();
  const { shouldShowLoader } = useInitialization();

  console.log('[RequireMenuInitialized] Estado atual:', {
    isInitialized,
    shouldShowLoader,
  });

  // Se deve mostrar loader de inicialização, não renderiza nada
  // REMOVIDO: Não bloquear renderização durante loading
  // if (shouldShowLoader) {
  //   console.log('[RequireMenuInitialized] Mostrando loader centralizado');
  //   return null;
  // }

  if (!isInitialized) {
    console.log('[RequireMenuInitialized] Menu não inicializado, aguardando...');
    return null; // O loader centralizado já está mostrando o progresso
  }

  console.log('[RequireMenuInitialized] ✅ Renderizando children');
  return <>{children}</>;
};

export default RequireMenuInitialized;
